import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './Banner.module.css';

const banner = (props) => {
  return (
    <div className={classes.BannerContainer}>
      <div className={classes.BannerContent}>
        <h3 className={classes.Title}>{props.title}: </h3>
        <p className={classes.Message}>{props.message}</p>
      </div>
      <FontAwesomeIcon icon="times" className={classes.DismissIcon} onClick={props.close} />
    </div>
  );
};

export default banner;
